import React, { useEffect, useRef, useState } from "react";
import "./MournerItem.scss";
import Avatar from "@material-ui/core/Avatar";
import { MyCheckbox } from "components";
import { ReactComponent as PrintIcon } from "assets/icons/print_yah.svg";
import { ReactComponent as CheckboxIcon } from "assets/icons/CheckboxIcon.svg";
import jsPDF from "jspdf";
import moment from "moment";
import { DateFormetContext } from "../../../../../app/App.js";
import html2canvas from "html2canvas";

import {
  Page,
  Document,
  StyleSheet,
  View,
  Image,
  Text,
} from "@react-pdf/renderer";

import Html from "react-pdf-html";
import { saveAs } from "file-saver";
import { pdf } from "@react-pdf/renderer";
import { useSelector } from "react-redux";

const MournerItem = ({
  key,
  id,
  item,
  profile_img,
  email,
  full_name,
  first_name,
  last_name,
  selectedRicipient,
  setSelectedRicipient,
  values,
  setFieldValue,
  templateContent,
  loading,
  imageLoading,
  templateContentImage,
  selectedMourners,
}) => {
  const dateFormet = React.useContext(DateFormetContext);
  const addLogo = useSelector((state) => state.CommonStates.addLogo);

  const orgData = JSON.parse(
    localStorage.getItem("organization") !== "undefined"
      ? localStorage.getItem("organization")
      : "{}"
  );

  const logoImg = orgData?.logoImg;
  const orgName = orgData?.orgName;
  const address = orgData?.contactInfo?.address;
  const phone = orgData?.contactInfo?.phone;

  console.log(orgData, "orgDataorgData");

  const handleAddMourner = (item) => {
    const mournerWithEmail = selectedMourners?.filter(
      (item) => item?.member_id?.email_address || item?.email
    );
    const mournerChecked = mournerWithEmail?.filter(
      (mo) =>
        mo?.member_id?._id === item?.member_id?._id || mo?.email === item?.email
    );
    setFieldValue("recipients", [...values?.recipients, ...mournerChecked]);
    setFieldValue("mournerWithEmailWithoutDuplicate", [
      ...values?.mournerWithEmailWithoutDuplicate,
      item,
    ]);
  };

  const htmlRender = templateContent
    ?.replace(/&lt;/g, "<")
    ?.replace(/&nbsp;/g, " ");

  const regex = /<strong>(.*?)<\/strong>/gi; // Regex to match <strong> tags
  const boldItalic = htmlRender?.replace(
    /<strong>(?=.*?<em>(.*?)<\/em>).*?<\/strong>/gi,
    '<span style="font-weight: bold; font-style: italic; font-family: Helvetica-BoldOblique;">$1</span>'
  );
  const boldReplaced = boldItalic?.replace(
    regex,
    '<span style="font-family: Helvetica-Bold;">$1</span>'
  );
  const italicHtml = boldReplaced
    ?.replace(
      /<em>/g,
      "<span style='font-style: italic; font-family: Helvetica-Oblique;'>"
    )
    .replace(/<\/em>/g, "</span>");
  const italicHtmll = italicHtml?.replace(
    /<i>(.*?)<\/i>/gi,
    '<span style="font-style: italic; font-family: Helvetica-Oblique;">$1</span>'
  );
  const lineThroughHtml = italicHtmll
    ?.replace(/<del>/g, '<span style="text-decoration: line-through">')
    .replace(/<\/del>/g, "</span>");
  const replacedHtml = lineThroughHtml
    ?.replace(/<ins>/g, '<span style="text-decoration: underline">')
    .replace(/<\/ins>/g, "</span>");

  const styles = StyleSheet.create({
    section: {
      padding: 30,
      fontStyle: "italic",
      flexDirection: "column",
      alignItems: "flex-start",
    },
    titleSection: {
      width: "99%",
      display: "flex",
      justifyContent: "space-between",
      flexDirection: "row",
    },
    titleSection2: {
      width: "99%",
      display: "flex",
      justifyContent: "left",
      flexDirection: "column",
    },
    text: { fontSize: 10 },
    italic: { fontStyle: "italic" },
    logo: {
      width: 130,
      height: 50,
    },
    headerText: {
      paddingBottom: 5,
      fontSize: 13,
    },
  });

  const MyDocument = ({ data }) => {
    return (
      <Document>
        <Page size="A4">
          <View style={styles.section}>
            {addLogo ? (
              <>
                <View style={styles.titleSection}>
                  <View style={styles.titleSection2}>
                    <Text style={styles.headerText}>{orgName}</Text>
                    <Text style={styles.headerText}>{address}</Text>
                    <Text style={styles.headerText}>{phone}</Text>
                  </View>
                  <Image src={logoImg} style={styles.logo} />
                </View>
              </>
            ) : null}
            <Html>{data}</Html>
          </View>
        </Page>
      </Document>
    );
  };
  const generatePdfDocument = async (htmlRender, item) => {
    const data = {
      ...item,
      ...item?.member_id,
    };
    const pdfFileName = item?.member_id?.full_name
      ? `Yehzreit Letter - ${item?.member_id?.full_name}`
      : item?.member_id?.first_name
      ? `Yehzreit Letter - ${item?.member_id?.first_name}`
      : `Yehzreit Letter - Mourner name`;

    //render the template with the data
    htmlRender = htmlRender?.replace(/\{\{([^}]+)\}\}/g, function (match, key) {
      return data[key] || "";
    });
    const blob = await pdf(<MyDocument {...{ data: htmlRender }} />).toBlob();
    saveAs(blob, pdfFileName);
    setFieldValue("printed", [...values?.printed, item?._id]);
  };
  return (
    <div className="mourner_item" key={key}>
      <div className="mourner_info">
        <Avatar src={profile_img} alt={full_name} className="mourner_avatar">
          {first_name &&
            last_name &&
            (first_name[0] + last_name[0]).toString().toUpperCase()}
        </Avatar>
        <div className="info">
          <div className="name">{full_name}</div>
          {email && <div className="email">{email}</div>}
        </div>
      </div>
      {email ? (
        <div className="mourner_checkbox">
          <MyCheckbox
            checked={
              values?.recipients?.length > 0 &&
              values?.recipients?.findIndex((item) => item?._id === id) !== -1
            }
            handlechange={(e) => {
              if (e.target.checked) {
                handleAddMourner(item);
                // setFieldValue('recipients', [...values?.recipients, item]);
                // setFieldValue("mournerWithEmailWithoutDuplicate", [...values?.mournerWithEmailWithoutDuplicate, item])
              } else {
                setFieldValue(
                  "recipients",
                  values?.recipients?.filter(
                    (rec) =>
                      rec?.member_id?._id !== item?.member_id?._id ||
                      rec?.email !== item?.email
                  )
                );
                setFieldValue(
                  "mournerWithEmailWithoutDuplicate",
                  values?.mournerWithEmailWithoutDuplicate?.filter(
                    (item) => item?._id !== id
                  )
                );
              }
            }}
          />
        </div>
      ) : (
        <div className="mourner_print">
          {values?.printed?.length > 0 ? (
            values?.printed?.findIndex((item) => item === id) !== -1 ? (
              <div className="printed">
                <CheckboxIcon className="mr-2" /> Printed!
              </div>
            ) : (
              <div className="print">
                {loading || imageLoading ? (
                  <div
                    className="spinner-border spinner-border-sm text-primary"
                    role="status"
                  />
                ) : (
                  <>
                    <div
                      onClick={() => generatePdfDocument(replacedHtml, item)}
                    >
                      <PrintIcon className="mr-3" />
                      Print
                    </div>
                  </>
                )}
              </div>
            )
          ) : (
            <div className="print">
              {loading || imageLoading ? (
                <div
                  className="spinner-border spinner-border-sm text-primary"
                  role="status"
                />
              ) : (
                <>
                  <div onClick={() => generatePdfDocument(replacedHtml, item)}>
                    <PrintIcon className="mr-3" />
                    Print
                  </div>
                </>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default MournerItem;
